import { render, staticRenderFns } from "./FireRiskDashboardHeader.view.vue?vue&type=template&id=17e90a76"
import script from "./FireRiskDashboardHeader.view.vue?vue&type=script&lang=ts&setup=true"
export * from "./FireRiskDashboardHeader.view.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports